/* eslint-disable */
import * as Sentry from "@sentry/browser";
import React from "react";

/**
 * Logs an error
 */
export const recordAppError = (error: any): void => {
  console.error(error);
  try {
    Sentry.captureException(error);
  } catch (error) {
    console.error("Error recording app error", error);
  }
};

/**
 * Logs a React Error.
 *
 * This util is only for logging React rendering issues, a case that is handled by our ErrorBoundarys most of the time.
 * For logging other errors (eg. data layer, business logic), see `recordAppError`
 */
export const recordReactError = (
  error: Error,
  errorInfo: React.ErrorInfo,
  opts: Record<string, unknown>
) => {
  try {
    const { componentStack } = errorInfo;
    Sentry.captureException(error, {
      // https://github.com/getsentry/sentry-javascript/blob/3fdab049623555bf89c72a3d3d8f9efacf208a07/packages/react/src/error.ts#L45
      captureContext: {
        contexts: {
          react: { componentStack },
        },
      },
      ...opts,
    });
  } catch (error) {
    console.error("Error recording React error", error);
  }
};

/**
 * Logs info abbout the app.
 * Commonly used to add additional context prior to logging an error.
 */
export const logAppInfo = (
  text: string,
  opts: {
    category?: string;
    level?: "info" | "warning" | "error";
    data?: Record<string, unknown>;
  } = {}
): void => {
  try {
    Sentry.addBreadcrumb({
      message: text,
      level: opts.level || "info",
      category: opts.category,
      data: opts.data,
    });
  } catch (error) {
    console.error("Error adding breadcrumb", error);
  }
};

export const setTag = (key: string, value: string) => {
  try {
    Sentry.setTag(key, value);
  } catch (error) {
    console.error("Error setting tag", error);
  }
};
